
type ApiPromise<T> = Promise<IFetchApiResponse<T>>;

export class StoreActionFactory {
  static api<T>(type: string, apiPromise: ApiPromise<T>, meta?: Partial<ActionContext>): IPayloadAction<ApiPromise<T>> {
    // Used to return a different shape, keeping this method for compat
    return StoreActionFactory.action<ApiPromise<T>>(type, apiPromise, meta);
  }

  static action<T>(type: string, payload: T, meta?): IPayloadAction<T> {
    return { type, payload, meta };
  }

  static thunk<TStore>(thunk: ThunkArg<TStore>): IThunkAction {
    return { type: "thunk", thunk };
  }
}